import { render, staticRenderFns } from "./IconList.vue?vue&type=template&id=6330d608&scoped=true"
var script = {}
import style0 from "./IconList.vue?vue&type=style&index=0&id=6330d608&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6330d608",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6330d608')) {
      api.createRecord('6330d608', component.options)
    } else {
      api.reload('6330d608', component.options)
    }
    module.hot.accept("./IconList.vue?vue&type=template&id=6330d608&scoped=true", function () {
      api.rerender('6330d608', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/gen/icon/IconList.vue"
export default component.exports